import { TextField } from "@mui/material";
import { useState } from "react";

function GenericNumberTextField(props) {
  const [value, setValue] = useState(props.value || 0);

  const handleChange = (event) => {
    let newValue = event.target.value;
    // Replace comma with period for internal state
    newValue = newValue.replace(',', '.');
    setValue(newValue);
    if (props.onChange) {
      // Pass the event with the modified value
      const modifiedEvent = {
        ...event,
        target: {
          ...event.target,
          value: newValue,
        },
      };
      props.onChange(modifiedEvent);
    }
  };

  const getStepValue = (value) => {
    const decimalPart = value.toString().split('.');
    return decimalPart ? Math.pow(10, -decimalPart.length) : 1;
  };

  return (
    <TextField
      {...props}
      value={value.toString().replace('.', ',')} // Display comma instead of period
      onChange={handleChange}
      fullWidth
      size="small"
      variant="outlined"
      type="text" // Use text type to allow comma input
      inputProps={{
        step: getStepValue(value),
      }}
    />
  );
}

export default GenericNumberTextField;
